import { createApi } from '@reduxjs/toolkit/query/react';

import { TagTypesEnum } from '@enum/tag-types.enum';
import { AccountInterface, AddAccountRequestInterface } from '@interface/account/account.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { portalQueryAuth } from '@util/api/portal-query-auth';

export const accountApi = createApi({
  reducerPath: 'account-api',
  tagTypes: [TagTypesEnum.Account],
  baseQuery: portalQueryAuth('/accounts'),
  endpoints: (build) => ({
    loadAccounts: build.query<ResponseDataInterface<AccountInterface[]>, void>({
      query: () => '/',
      providesTags: [TagTypesEnum.Account],
    }),
    addAccount: build.mutation<ResponseDataInterface<AccountInterface>, AddAccountRequestInterface>({
      query: (credentials) => ({
        url: '/',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: [TagTypesEnum.Account],
    }),
    getAccountUsage: build.query<ResponseDataInterface<{ usageQuantity: string }>, string>({
      query: (accountId: string) => `/${accountId}/usage`,
    }),
  }),
});
